module.exports = __webpack_public_path__ + "static/media/get-storage-t2.6c0cac37.nom";